import { ClockIcon } from "@heroicons/react/24/outline";
import { useStore } from "@nanostores/react";
import { ReactElement, useState } from "react";

import IconProgress from "../../assets/icons/progress.svg";
import { $workflowsByGraphID } from "../../stores/workflows.ts";
import { GraphEdgeStatusFilterType } from "../../types/graph.ts";
import { GraphLogsTabs } from "../GraphLogsTabs.tsx";
import { FloatingLogsTable } from "./FloatingLogsTable.tsx";
import { FloatingTool } from "./FloatingTool.tsx";

export const FloatingLogs = (): ReactElement => {
  const [currentLogsFilter, setCurrentLogsFilter] =
    useState<GraphEdgeStatusFilterType>("all");

  const { data } = useStore($workflowsByGraphID);
  const hasPendingWorkflows = data?.some(
    (workflow) => workflow.status === "RUNNING",
  );

  const logsIcon = (
    <div className="relative">
      <ClockIcon className="h-6 w-6 cursor-pointer text-zinc-400 hover:text-zinc-200" />
      {hasPendingWorkflows && (
        <div className="absolute -bottom-1 -right-1">
          <IconProgress className="h-3 w-3 animate-spin rounded-full bg-zinc-900 text-sky-500" />
        </div>
      )}
    </div>
  );

  const logsContent = (
    <div className="ring-.75 max-h-[400px] min-w-[600px] overflow-hidden rounded-lg bg-zinc-900/90 p-3 shadow-lg ring-zinc-600">
      <div className="flex flex-col space-y-3">
        {/* Logs Filter Tabs */}
        <div className="flex items-center space-x-3">
          <GraphLogsTabs
            currentTab={currentLogsFilter}
            onClick={setCurrentLogsFilter}
          />
        </div>

        {/* Logs Table */}
        <div className="max-h-[300px] overflow-y-auto">
          <FloatingLogsTable statusFilter={currentLogsFilter} />
        </div>
      </div>
    </div>
  );

  return <FloatingTool icon={logsIcon}>{logsContent}</FloatingTool>;
};
